export default __webpack_public_path__ + "static/media/BannerHeader.11beab2b.jpg";